// jQueryプラグイン
import 'jquery.easing';
/* -----------------------------------------------------
ページ内リンクのアニメーション
------------------------------------------------------- */
export function pageMoveAnkerFunc() {
  var headerHeight, position;
  $('a[href^="#"]:not(.notScroll)').each(function () {
    var pageUrl = location.href.split('#')[0];
    if (this.href.indexOf(pageUrl + '#') === 0) {
      var id = this.href.split('#')[1];
      $(this).on('click', function () {
        
        var isSP = window.innerWidth < 768;

        // SP（767px以下）のときは「.drawerScroll」を動かす
        // PC（768px以上）のときは「body,html」を動かす
        var $scrollTarget = isSP ? $('.drawerScroll') : $('body,html');

        if (isSP) {
          headerHeight = 10;
        } else {
          headerHeight = 20;
        }

        // ターゲット要素（スクロール先）が存在するかチェック
        var $target = $('#' + id);
        if ($target.length) {
          
          if (isSP) {
            position = $scrollTarget.scrollTop() + ($target.offset().top - $scrollTarget.offset().top) - headerHeight;
          } else {
            position = $target.offset().top - headerHeight;
          }

          $scrollTarget.stop().animate({
            scrollTop: position
          }, 1000, 'easeInOutQuart');
        }

        return false;
      });
    }
  });
}